import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import LoginForm from "../auth/login-form";
import image from "../../assets/images/login.svg";
// import logo from "../../assets/images/logo.png";
import "../../Routes/app.scss";
import "../../styles/alerts.scss";
import "../../styles/buttons.scss";
import "../../styles/datepickers.scss";
import "../../styles/forms.scss";
import "../../styles/inputs.scss";
import "../../styles/modals.scss";
import "../../styles/notifications.scss";
import "../../styles/pagination.scss";
import "../../styles/selects.scss";
import "../../styles/switches.scss";
import "../../styles/tabs.scss";
import "../../styles/tags.scss";
import classes from "./Login.module.scss";
import { useAuth } from "../hooks/UseAuth";
import { getToken } from "../../services/security";
import { Navigate } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";

function App() {
  let { validate, setAuthenticated, authenticated } = useAuth();
  let token = getToken();
  const [Loading, setLoading] = useState(false);
  const isLogin = async () => {
    setLoading(true);
    let result = await validate();
    setAuthenticated(result);
    setLoading(false);
  };
  useEffect(() => {
    if (token) {
      isLogin();
    }
  }, []);
  if (!Loading) {
    return !authenticated ? (
      <div className="App">
        <Row>
          <Col xs={0} lg={16}>
            <div className={classes.image}>
              <img className={classes.background} src={image} alt="login" />
              {/* <img className={classes.logo} src={logo} alt="logo" /> */}
            </div>
          </Col>
          <Col xs={24} lg={8}>
            <div className={classes.form}>
              <LoginForm />
            </div>
          </Col>
        </Row>
      </div>
    ) : (
      <Navigate to="/" />
    );
  } else {
    return (
      <>
        <div className={classes.Loading}>
          <SpinnerCircular
            size="60px"
            thickness={150}
            color="#1597d4"
            secondaryColor="#eeedfd"
          />
        </div>
      </>
    );
  }
}

export default App;
